import React from "react";

import {
  Card,
  CardBody,
  CardFooter,
  CardTitle,
  Content,
  Label,
  Stack,
  StackItem
} from "@patternfly/react-core";

const VideoCard = ({
  title,
  description,
  youtubeId,
  footer = null
}) => (
  <Card isFullHeight isGlass>
    <iframe
      src={`https://www.youtube.com/embed/${youtubeId}`}
      title={title}
      loading="lazy"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      allowFullScreen
      style={{
        display: "block",
        width: "100%",
        aspectRatio: "16 / 9",
        border: 0
      }}
    />

    <CardTitle>
      <Stack hasGutter>
        <StackItem isFilled/>
        <StackItem>
          <Label color="red">
            YouTube
          </Label>
        </StackItem>

        <StackItem>
          <Content component="h2">
            {title}
          </Content>
        </StackItem>
      </Stack>
    </CardTitle>

    {description && (
      <CardBody>
        <Content component="p">
          {description}
        </Content>
      </CardBody>
    )}

    {footer && (
      <CardFooter>
        {footer}
      </CardFooter>
    )}
  </Card>
);

export default VideoCard;